import en from '@/translations/en';
import { createI18n } from 'vue-i18n';

type MessageSchema = typeof en;

const messages = {} as { [key: string]: MessageSchema };
const supported = ['en'];
const availableLocales = [
  {
    code: 'en',
    flag: 'us',
    label: 'English',
    messages: en,
  },
];

let locale = 'en';

try {
  const browserLang = navigator.language.split('-')[0];

  if (browserLang && supported.includes(browserLang)) locale = browserLang;
} catch (error) {
  console.log(error);
}

for (const l of availableLocales) {
  messages[l.code] = l.messages;
}

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: import.meta.env.VITE_APP_DEFAULT_LANGUAGE as string,
  messages,
  mode: 'composition',
});

export default i18n;
